module.exports = __webpack_public_path__ + "static/codeable-8a6dc6c93f23b7488152f9aa03d31e71.svg";